<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import Vue from "vue";
import mask from "vuejs-mask";
import store from "./store/store";
import VueToast from "vue-toast-notification";
import moment from "moment";
import * as cnpj from "@fnando/cnpj";
import * as cpf from "@fnando/cpf";


Vue.use(mask);
Vue.use(VueToast);

Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY");
  }
});

Vue.filter("formatHour", function (value) {
  if (value) {
    return moment(String(value)).format("HH:mm");
  }
});

Vue.filter("formatDateTime", function (value) {
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY HH:mm:ss");
  }
});

Vue.filter("formatCPFCNPJ", function (value) {
  if (value.length === 11) {
    return cpf.format(value);
  } else if (value.length === 14) {
    return cnpj.format(value);
  }
  return value;
});

Vue.filter("formatCurrency", function (value) {
  if (value) {
    let val = (value / 1).toFixed(2).replace(".", ",");
    return "R$ " + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
});

export default {
  name: "App",
  data() {
    return {};
  },

  created: function () {
    this.$http.interceptors.response.use((response) => {
      return response;
    }, (error) => {
      if (error.response.status === 401 && this.$router.currentRoute.name !== 'Login') {
        store.dispatch("logout").then(() => {
          this.$router.push(`/${localStorage.getItem('group')}`).catch(() => {});
        });
      }
      return Promise.reject(error);
    });
  },
};
</script>

<style>
@import "./../static/css/theme-sugar.css";

#app {
  font-family: "Nunito", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  position: relative;
}
.background-login {
  height: 100vh; /* Center and scale the image nicely */
  background-repeat: no-repeat center;
  background-size: cover;
}

body {
  background-color: #ebe7e7;
}

button:focus {
  outline: 0;
}

.hide {
  display: none !important;
}

.modal-backdrop {
  display: none;
}

.modal {
  background: rgba(0, 0, 0, 0.5);
}

.form-control {
  outline: none !important;
}
pre {
  font: inherit;
  color: rgb(100, 95, 95);
  margin: 0;
  padding: 0;
  border: 0;
  font: inherit;
}


</style>



// WEBPACK FOOTER //
// src/App.vue